import React from "react";
import ReactPlayer from "react-player";
import {Box, Button, Typography} from "@mui/material";

import resourceData from "../../../../../assets/data/educationHub/resourceListData";
import DownloadBlueIcon from '../../../../../assets/images/svgs/download.svg';
import {downloadVideoFile} from "../../../../common.helper";
import {styles} from "./featuredContent-helpers";
import TransMsg from '../../transMessage'

export const VideoCardComponent = ({t}: any) => {
    const cardItemList = resourceData.featureList

    const onClickVideo = (url: string) => {
        downloadVideoFile(url)
    }

    return (
        <Box mt={"68px"} display={"flex"} gap={"16px"} flexWrap={"wrap"}>
            {cardItemList.map((item, index) => {

                return (
                    <Box key={index + 1} sx={styles.videoCardWrapper} textAlign={"left"}>
                        <Box sx={{maxWidth: "433px", maxHeight: "292px"}}>

                            {item.thumbNailUrl && (
                                <div style={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "56.25%", // 16:9 ratio
                                    borderRadius: "8px",
                                    overflow: "hidden"
                                }}>
                                    <ReactPlayer
                                        url={item.videoUrl}
                                        light={encodeURI(item.thumbNailUrl)}
                                        controls
                                        playing={true}
                                        width="100%"
                                        height="100%"
                                        style={{ position: "absolute", top: 0, left: 0 }}
                                    />
                                </div>

                            )}
                        </Box>
                        <Box sx={{p: "12.9px", pb: "20px"}}>
                            <Box display={"flex"}>
                                <Typography sx={styles.titleTextStyle}>
                                    {item.title}
                                </Typography>
                                {item?.isDownloadAvailable ?
                                    <Button sx={{display: "flex"}} onClick={() => onClickVideo(item?.videoUrl)}>
                                        <img src={DownloadBlueIcon} alt="download-icon"
                                             style={{paddingRight: "8px", width: "15px", height: "17px"}}/>
                                        <Typography sx={styles.downloadLabelStyle}>
                                            {t(TransMsg.DOWNLOAD_BTN)}
                                        </Typography>
                                    </Button>
                                    : null
                                }
                            </Box>
                            <Typography sx={styles.itemDesc}>
                                {item.description}
                            </Typography>
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}